import {
  generatedDiscountCodeManagementRowSchema,
  generatedDiscountCodeManagementSortKeys,
} from "@redotech/redo-discounts-common/generated-discount-code-management";
import { SortDirection } from "@redotech/redo-views-common/table";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

/**
 * ISO instants for the picked range: the start of the first day and the start
 * of the day after the last one, both in the merchant's time zone. Leave them
 * out for all time.
 */
const createdAtRangeSchema = {
  startAt: z.string().optional(),
  endBefore: z.string().optional(),
};

export const getCheckoutPlusRewardCodes = {
  name: "getCheckoutPlusRewardCodes" as const,
  input: z.object({
    page: z.number().int().positive().default(1),
    pageSize: z.number().int().positive().max(100).default(50),
    sortKey: z
      .enum(generatedDiscountCodeManagementSortKeys)
      .default("createdAt"),
    sortDirection: createEnum(SortDirection).default(SortDirection.DESC),
    searchString: z.string().optional(),
    ...createdAtRangeSchema,
  }),
  output: z.object({
    codes: z.array(generatedDiscountCodeManagementRowSchema),
    totalCount: z.number(),
  }),
};

export const getCheckoutPlusRewardSummary = {
  name: "getCheckoutPlusRewardSummary" as const,
  input: z.object(createdAtRangeSchema),
  output: z.object({
    issued: z.number(),
    redeemed: z.number(),
    /** True when the team has any reward code, whatever the date range. */
    hasRewardCodes: z.boolean(),
  }),
};
